import { withCompController } from '@wix/editor-elements-integrations';
import {
  LineShareButtonMapperProps,
  LineShareStateRefs,
  LineShareButtonControllerProps,
} from '../LineShareButton.types';
import { mapConsentPolicyStateRefValues } from '../../ConsentPolicyWrapper/viewer/utils';

const compController = withCompController<
  LineShareButtonMapperProps,
  LineShareButtonControllerProps,
  never,
  LineShareStateRefs
>(({ stateValues, mapperProps }) => {
  return {
    ...mapperProps,
    currentUrl: stateValues.currentUrlWithQueryParams,
    ...mapConsentPolicyStateRefValues(stateValues),
  };
});

export default compController;
